export const mobilePopupBtnHeight = 65;
export const mobilePopupBtnMargin = 4;
export const mobilePopupBtnOuterHeight =
  mobilePopupBtnHeight + mobilePopupBtnMargin * 2;
export const mobilePopupPaddings = 16;